function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export { default as gql } from 'graphql-tag';
export * from 'apollo-client';
import { ApolloLink, Observable } from 'apollo-link';
export * from 'apollo-link';
import { InMemoryCache } from 'apollo-cache-inmemory';
export * from 'apollo-cache-inmemory';
import { Apollo, ApolloModule } from 'apollo-angular';
export * from 'apollo-angular';
import { InjectionToken, Injectable, NgModule, Optional, Inject } from '@angular/core';
import { HttpLink, HttpLinkModule } from 'apollo-angular-link-http';
import { withClientState } from 'apollo-link-state';
import { onError } from 'apollo-link-error';
var APOLLO_BOOST_CONFIG = new InjectionToken('[apollo-angular-boost] config');
var ApolloBoost = /*#__PURE__*/function () {
  function ApolloBoost(apollo, httpLink) {
    _classCallCheck(this, ApolloBoost);
    this.apollo = apollo;
    this.httpLink = httpLink;
  }
  _createClass(ApolloBoost, [{
    key: "create",
    value: function create(config) {
      var cache = config && config.cacheRedirects ? new InMemoryCache({
        cacheRedirects: config.cacheRedirects
      }) : new InMemoryCache();
      var stateLink = config && config.clientState ? withClientState(Object.assign(Object.assign({}, config.clientState), {
        cache: cache
      })) : false;
      var errorLink = config && config.onError ? onError(config.onError) : onError(function (_ref) {
        var graphQLErrors = _ref.graphQLErrors,
          networkError = _ref.networkError;
        if (graphQLErrors) {
          graphQLErrors.map(function (_ref2) {
            var message = _ref2.message,
              locations = _ref2.locations,
              path = _ref2.path;
            return (
              // tslint:disable-next-line
              console.log("[GraphQL error]: Message: ".concat(message, ", Location: ").concat(locations, ", Path: ").concat(path))
            );
          });
        }
        if (networkError) {
          // tslint:disable-next-line
          console.log("[Network error]: ".concat(networkError));
        }
      });
      var requestHandler = config && config.request ? new ApolloLink(function (operation, forward) {
        return new Observable(function (observer) {
          var handle;
          Promise.resolve(operation).then(function (oper) {
            return config.request(oper);
          }).then(function () {
            handle = forward(operation).subscribe({
              next: observer.next.bind(observer),
              error: observer.error.bind(observer),
              complete: observer.complete.bind(observer)
            });
          })["catch"](observer.error.bind(observer));
          return function () {
            if (handle) {
              handle.unsubscribe();
            }
          };
        });
      }) : false;
      var httpLink = this.httpLink.create(Object.assign(Object.assign({}, config && config.httpOptions || {}), {
        uri: config && config.uri || '/graphql'
      }));
      var link = ApolloLink.from([errorLink, requestHandler, stateLink, httpLink].filter(function (x) {
        return !!x;
      }));
      this.apollo.create({
        link: link,
        cache: cache
      });
    }
  }]);
  return ApolloBoost;
}();
ApolloBoost.decorators = [{
  type: Injectable
}];
ApolloBoost.ctorParameters = function () {
  return [{
    type: Apollo
  }, {
    type: HttpLink
  }];
};
var ApolloBoostModule = /*#__PURE__*/_createClass(function ApolloBoostModule(boost, config) {
  _classCallCheck(this, ApolloBoostModule);
  if (config) {
    boost.create(config);
  }
});
ApolloBoostModule.decorators = [{
  type: NgModule,
  args: [{
    imports: [ApolloModule, HttpLinkModule],
    providers: [ApolloBoost]
  }]
}];
ApolloBoostModule.ctorParameters = function () {
  return [{
    type: ApolloBoost
  }, {
    type: undefined,
    decorators: [{
      type: Optional
    }, {
      type: Inject,
      args: [APOLLO_BOOST_CONFIG]
    }]
  }];
};

/**
 * Generated bundle index. Do not edit.
 */

export { APOLLO_BOOST_CONFIG, ApolloBoost, ApolloBoostModule };